import axios from "axios";
import { JOB_REQUESTS_URL, JOB_REQUESTS_DRAFT_URL } from "../utils";

export const fetchJobRequests = (isDraft: boolean = false) => {
  return axios.get(isDraft ? JOB_REQUESTS_DRAFT_URL : JOB_REQUESTS_URL);
};
